import { parseColor } from '../parse';
export function rgba(color, a) {
    const rgb = parseColor(color);
    return `rgba(${rgb.r},${rgb.g},${rgb.b},${a})`;
}
//# sourceMappingURL=rgba.js.map